import React, { useState } from 'react';
import {
    Modal, Popconfirm, Table, Checkbox, Input, Select, DatePicker, TimePicker, Form, Button, Tabs, ConfigProvider
} from 'antd';
import {
    ShoppingBag, RotateCcw, XCircle, AlertCircle, Wrench, Search, Paperclip, Smile, Send, ChevronDown,
    Minus, Plus, LogOut, SlidersHorizontal, Filter, RefreshCw, ArrowLeft,
} from 'lucide-react';
import Layout from '../../Layout'

const { TextArea } = Input;

// ==========================================
// 1. DỮ LIỆU MẪU (MOCK DATA)
// ==========================================
const historyData = [
    {
        key: '1', date: '25/06/2026', action: 'Cấp phát', code: 'BBBG_115', qty: 1,
        revokeQty: '--', related: '--', executor: 'B', assetId: 'TS.247',
        handover: 'Cá nhân', representative: 'Lê Hòa Bình', dept: 'Tổng Công ty Phân bón...\nkế toán'
    },
];

const historyColumns = [
    { title: 'NGÀY', dataIndex: 'date', key: 'date' },
    { title: 'HÀNH ĐỘNG', dataIndex: 'action', key: 'action' },
    { title: 'MÃ', dataIndex: 'code', key: 'code' },
    { title: 'SỐ LƯỢNG', dataIndex: 'qty', key: 'qty', align: 'center' },
    { title: 'NGƯỜI THỰC HIỆN', dataIndex: 'representative', key: 'representative' },
    { title: 'MÃ TS', dataIndex: 'assetId', key: 'assetId' },
];

const assetHistoryData = [
    { key: '1', date: '25/06/2026', action: 'Tạo mới', startQty: 0, qty: '+10,000', endQty: '10,000', price: '' },
    { key: '2', date: '25/06/2026', action: 'Cấp phát', startQty: '10,000', qty: '-1', endQty: '9,999', price: '' },
    { key: '3', date: '12/08/2026', action: 'Thanh lý tài sản', startQty: '9,999', qty: '-1', endQty: '9,998', price: '1' },
];

const assetHistoryColumns = [
    { title: 'NGÀY', dataIndex: 'date', key: 'date' },
    { title: 'TÁC VỤ', dataIndex: 'action', key: 'action' },
    { title: 'TỒN ĐẦU KỲ', dataIndex: 'startQty', key: 'startQty' },
    { title: 'SỐ LƯỢNG', dataIndex: 'qty', key: 'qty' },
    { title: 'TỒN CUỐI KỲ', dataIndex: 'endQty', key: 'endQty' },
    { title: 'SỐ TIỀN', dataIndex: 'price', key: 'price' },
];

// ==========================================
// 2. COMPONENT CON HIỂN THỊ
// ==========================================

// Item hiển thị thông tin dạng Label - Value
const InfoItem = ({ label, value }) => (
    <div className="mb-6">
        <p className="text-gray-500 dark:text-gray-400 text-[13px] mb-1.5">{label}</p>
        <p className="text-gray-800 dark:text-gray-200 text-[13px] font-medium">{value}</p>
    </div>
);

// Khối Panel Trắng có nút đóng mở (Accordion)
const CollapsibleSection = ({ title, extra, children, defaultExpanded = true, noPadding = false }) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);
    return (
        <div className="bg-white dark:bg-gray-800 rounded-md shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden transition-all duration-300">
            {/* Header: Click vào cả vùng header để đóng/mở */}
            <div
                className="flex justify-between items-center px-5 py-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <h3 className="text-[15px] font-bold text-gray-800 dark:text-gray-200">{title}</h3>
                <div className="flex items-center space-x-3 text-gray-400">
                    {/* Ngăn sự kiện click ở extra lây lan ra ngoài */}
                    {extra && <div onClick={e => e.stopPropagation()} className="cursor-pointer hover:text-gray-600 transition-colors">{extra}</div>}
                    <button className="outline-none text-gray-400 hover:text-gray-700 dark:hover:text-gray-200">
                        {isExpanded ? <Minus size={18} strokeWidth={1.5} /> : <Plus size={18} strokeWidth={1.5} />}
                    </button>
                </div>
            </div>
            {isExpanded && (
                <div className={`border-t border-gray-100 dark:border-gray-700 animate-fade-in ${noPadding ? '' : 'p-5'}`}>
                    {children}
                </div>
            )}
        </div>
    );
};

// ==========================================
// 3. COMPONENT CHÍNH
// ==========================================
const AssetDetail = () => {
    const [isAllocateOpen, setIsAllocateOpen] = useState(false);
    const [isRevokeOpen, setIsRevokeOpen] = useState(false);
    const [isBrokenOpen, setIsBrokenOpen] = useState(false);
    const [isMaintenanceOpen, setIsMaintenanceOpen] = useState(false);

    // TAB 1: THÔNG TIN CHUNG
    const TabGeneralContent = (
        <div className="p-5 animate-fade-in">
            <div className="grid grid-cols-2 gap-x-8 gap-y-1 border-b border-gray-100 dark:border-gray-700 pb-2 mb-6">
                <InfoItem label="Mã TS" value="TS.247" />
                <InfoItem label="Tên tài sản" value="1tesst" />
                <InfoItem label="Model / Series" value="--" />
                <InfoItem label="Đơn vị" value="Chiếc" />
                <InfoItem label="Loại tài sản" value="--" />
                <InfoItem label="Ngày mua" value="25/06/2026" />
                <InfoItem label="Ngày kết thúc BH" value="--" />
                <InfoItem label="Thời gian BH (tháng)" value="-" />
                <InfoItem label="Khấu hao (tháng)" value="-" />
                <InfoItem label="Nhà cung cấp" value="--" />
                <InfoItem label="Pháp nhân sở hữu" value="--" />
                <InfoItem label="Phòng ban quản lý" value="CÔNG TY CỔ PHẦN KhoThi" />
                <InfoItem label="Vị trí tài sản" value="--" />
                <InfoItem label="Trạng thái" value="Đang sử dụng" />
                <InfoItem label="Phòng ban sử dụng" value="Phòng kế toán" />
                <div className="mb-6">
                    <p className="text-gray-500 text-[13px] mb-1.5">Nhân sự sử dụng</p>
                    <span className="inline-block bg-orange-100 text-orange-600 font-medium text-[11px] px-2 py-0.5 rounded-sm">Lê Hòa Bình</span>
                </div>
            </div>

            <h3 className="font-bold text-[15px] text-gray-800 dark:text-gray-200 mb-6">Giá trị tài sản</h3>
            <div className="grid grid-cols-2 gap-x-8 gap-y-1">
                <InfoItem label="Số lượng" value="9,999 Chiếc" />
                <InfoItem label="Nguyên giá" value="0 VNĐ" />
                <InfoItem label="Giá mua" value="--" />
                <InfoItem label="Đang sử dụng" value="1 Chiếc" />
                <InfoItem label="SL còn" value="9998 Chiếc" />
                <InfoItem label="Giá trị khấu hao" value="0" />
            </div>
        </div>
    );

    // TAB 2: ẢNH TÀI SẢN
    const TabImagesContent = (
        <div className="p-6 h-[500px] relative bg-[#fafafa] dark:bg-gray-800/50 animate-fade-in flex">

            {/* Khối Ảnh Tài Sản (To, nằm bên trái) */}
            <div className="w-1/2 h-full bg-[#f0f0f0] dark:bg-gray-700 flex flex-col items-center justify-center text-gray-500 border border-gray-200 dark:border-gray-600 rounded">
                {/* Icon ảnh */}
                <svg width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="mb-4 text-gray-400">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <circle cx="8.5" cy="8.5" r="1.5"></circle>
                    <polyline points="21 15 16 10 5 21"></polyline>
                </svg>
                <span className="text-[22px] font-bold tracking-wide text-gray-500">NO PRODUCT IMAGE</span>
            </div>

            {/* Khối QR Code (Nằm ở góc dưới cùng bên phải) */}
            <div className="absolute bottom-6 right-6 w-20 h-20 bg-white p-1 rounded shadow-sm border border-gray-200">
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/d/d0/QR_code_for_mobile_English_Wikipedia.svg"
                    alt="QR Code"
                    className="w-full h-full object-contain"
                />
            </div>

        </div>
    );

    return (
        <Layout>
            {/* TOOLBAR */}
            <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-2 md:px-4 py-2 flex md:flex-row flex-col justify-start md:justify-between md:items-center items-start sticky top-[64px] z-10 shadow-sm md:gap-0 gap-1">
                <div className="flex items-center">
                    <a href="/assets/list" className="w-8 h-8 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 flex items-center justify-center text-gray-500 dark:text-gray-400 mr-1 transition-colors">
                        <ArrowLeft size={16} />
                    </a>
                    <h2 className="font-bold text-gray-800 dark:text-gray-100 whitespace-nowrap">Thông tin chung</h2>
                </div>
                <div className="overflow-x-auto scrollbar-hide w-full">
                    <div className="flex justify-start md:justify-end items-center space-x-3 md:space-x-4 whitespace-nowrap">
                        <button onClick={() => setIsAllocateOpen(true)} className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-orange-500 font-medium transition-colors outline-none shrink-0">
                            <ShoppingBag size={14} className="mr-1.5" /> Cấp phát
                        </button>
                        <button onClick={() => setIsRevokeOpen(true)} className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-orange-500 font-medium transition-colors outline-none shrink-0">
                            <RotateCcw size={14} className="mr-1.5" /> Thu hồi
                        </button>
                        <Popconfirm title="Xác nhận" description="Bạn có chắc chắn thực hiện tác vụ này?" okText="ĐỒNG Ý" cancelText="HỦY BỎ" okButtonProps={{ className: 'bg-orange-500 hover:bg-orange-600 border-none' }}>
                            <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-orange-500 font-medium transition-colors outline-none shrink-0">
                                <XCircle size={14} className="mr-1.5" /> Báo hủy
                            </button>
                        </Popconfirm>
                        <button onClick={() => setIsBrokenOpen(true)} className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-orange-500 font-medium transition-colors outline-none shrink-0">
                            <AlertCircle size={14} className="mr-1.5" /> Báo hỏng
                        </button>
                        <button onClick={() => setIsMaintenanceOpen(true)} className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-orange-500 font-medium transition-colors outline-none shrink-0">
                            <Wrench size={14} className="mr-1.5" /> Bảo trì, sửa chữa
                        </button>
                    </div>
                </div>
            </div>

            {/* NỘI DUNG CHÍNH */}
            <div className="mx-auto py-4 grid grid-cols-1 lg:grid-cols-3 gap-5 items-start mt-2">

                {/* CỘT TRÁI (Sử dụng flex col và gap để tạo khoảng cách giữa các khối) */}
                <div className="lg:col-span-2 flex flex-col gap-5">

                    {/* KHỐI 1: TABS THÔNG TIN CHUNG / ẢNH TÀI SẢN */}
                    <div className="bg-white dark:bg-gray-800 rounded-md shadow-sm border border-gray-200 dark:border-gray-700">
                        <Tabs
                            defaultActiveKey="1"
                            className="px-4 pt-2 custom-antd-tabs"
                            items={[
                                { key: '1', label: 'Thông tin chung', children: TabGeneralContent },
                                { key: '2', label: 'Ảnh tài sản', children: TabImagesContent }
                            ]}
                        />
                    </div>

                    {/* KHỐI 2: CẤP PHÁT THU HỒI (Nằm ngoài Tabs) */}
                    <CollapsibleSection title="Cấp phát thu hồi" extra={<LogOut size={18} strokeWidth={1.5} />} noPadding>
                        <ConfigProvider theme={{ components: { Table: { headerBg: '#f9fafb', headerColor: '#4b5563' } } }}>
                            <Table
                                columns={historyColumns}
                                dataSource={historyData}
                                pagination={false}
                                size="middle"
                                scroll={{ x: 'max-content' }}
                                className="custom-inner-table"
                            />
                        </ConfigProvider>
                    </CollapsibleSection>

                    {/* KHỐI 3: LỊCH SỬ TÀI SẢN (Nằm ngoài Tabs) */}
                    <CollapsibleSection title="Lịch sử tài sản" noPadding>
                        <ConfigProvider theme={{ components: { Table: { headerBg: '#f9fafb', headerColor: '#4b5563' } } }}>
                            <Table
                                columns={assetHistoryColumns}
                                dataSource={assetHistoryData}
                                pagination={false}
                                size="middle"
                                scroll={{ x: 'max-content' }}
                                className="custom-inner-table"
                            />
                        </ConfigProvider>
                    </CollapsibleSection>

                    {/* KHỐI 4: TRƯỜNG TÙY CHỈNH (Nằm ngoài Tabs) */}
                    <CollapsibleSection title="Trường tùy chỉnh">
                        <div className="grid grid-cols-2 gap-x-8 gap-y-1">
                            <InfoItem label="Địa điểm" value="--" />
                            <InfoItem label="Nước sản xuất" value="--" />
                            <InfoItem label="Năm sản xuất" value="--" />
                            <InfoItem label="Năm sử dụng" value="--" />
                            <div className="mb-5">
                                <p className="text-gray-500 text-[13px] mb-2">Bảo trì/Bảo dưỡng</p>
                                <div className="space-y-2">
                                    <Checkbox disabled>Nội bộ</Checkbox><br />
                                    <Checkbox disabled>Hãng</Checkbox>
                                </div>
                            </div>
                            <InfoItem label="Chu kỳ BTBD" value="--" />
                            <InfoItem label="Thời gian kiểm định" value="--" />
                            <InfoItem label="Không kiểm định" value="--" />
                        </div>
                    </CollapsibleSection>

                </div>

                {/* CỘT PHẢI */}
                <div className="lg:col-span-1 space-y-5 sticky top-[113px]">
                    {/* Hộp Ảnh tài sản nhỏ */}
                    <div className="bg-white dark:bg-gray-800 rounded-md shadow-sm border border-gray-200 dark:border-gray-700 p-5">
                        <h3 className="font-bold text-[15px] text-gray-800 dark:text-gray-200 mb-4 border-b border-gray-100 dark:border-gray-700 pb-3">Ảnh tài sản</h3>

                        {/* Thêm class 'relative' để làm mốc định vị cho QR code bên trong */}
                        <div className="bg-gray-50 dark:bg-gray-700 h-64 rounded flex flex-col items-center justify-center relative border border-gray-100 dark:border-gray-600">
                            {/* Icon / Text No Product Image */}
                            <div className="text-center text-gray-400">
                                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="mx-auto mb-2 text-gray-400">
                                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                    <circle cx="8.5" cy="8.5" r="1.5"></circle>
                                    <polyline points="21 15 16 10 5 21"></polyline>
                                </svg>
                                <span className="text-xs font-bold tracking-wide text-gray-400">NO PRODUCT IMAGE</span>
                            </div>

                            {/* QR Code nằm góc dưới bên phải, nằm bên trong khung xám */}
                            <div className="absolute bottom-3 right-3 w-14 h-14 bg-white p-1 rounded shadow-sm border border-gray-200">
                                <img
                                    src="https://upload.wikimedia.org/wikipedia/commons/d/d0/QR_code_for_mobile_English_Wikipedia.svg"
                                    alt="QR Code"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Lịch sử */}
                    <div className="bg-white dark:bg-gray-800 rounded-md shadow-sm border border-gray-200 dark:border-gray-700">
                        <Tabs
                            defaultActiveKey="2"
                            className="px-4 pt-2 custom-antd-tabs"
                            items={[
                                {
                                    key: '1', label: 'Thảo luận',
                                    children: (
                                        <div className="p-5 pt-0">
                                            <div className="text-center py-10 text-gray-400"><p>Không có thảo luận nào</p></div>
                                            <div className="relative mt-2">
                                                <Input placeholder="Viết thảo luận..." className="rounded-full pl-10 pr-20 py-2.5 bg-gray-50 border-gray-200" />
                                                <div className="absolute right-4 top-3 flex space-x-3 text-gray-400">
                                                    <Paperclip size={16} className="cursor-pointer hover:text-gray-600" />
                                                    <Smile size={16} className="cursor-pointer hover:text-gray-600" />
                                                    <Send size={16} className="cursor-pointer hover:text-orange-500" />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                },
                                {
                                    key: '2',
                                    label: 'Lịch sử hoạt động',
                                    children: (
                                        <div className="pb-4">
                                            {/* Khung chứa Timeline */}
                                            <div className="relative pl-6 space-y-4 max-h-[450px] overflow-y-auto pr-1">

                                                {/* Trục dọc (Đường line màu xám chạy dọc timeline) */}
                                                <div className="absolute left-[11px] top-3 bottom-3 w-0.5 bg-gray-200 dark:bg-gray-700"></div>

                                                {/* --- ITEM TIMELINE 1 --- */}
                                                <div className="relative flex items-start group">
                                                    {/* Icon tròn màu hồng bên trái */}
                                                    <div className="absolute -left-6 top-2 w-6 h-6 rounded-full bg-[#f43f5e] text-white flex items-center justify-center shadow-sm z-10">
                                                        <ShoppingBag size={12} />
                                                    </div>
                                                    {/* Card nội dung */}
                                                    <div className="flex-1 bg-[#f8f9fa] dark:bg-gray-800 p-4 rounded-md border border-gray-100 dark:border-gray-700 relative ml-2">
                                                        <div className="flex justify-between items-start">
                                                            <div>
                                                                <p className="text-[13px] text-gray-800 dark:text-gray-200">
                                                                    <span className="font-bold">Mr. Huân</span> <span className="text-gray-500">đã thanh lý tài sản</span>
                                                                </p>
                                                                <p className="text-[11px] text-gray-400 mt-0.5 flex items-center">
                                                                    <span className="mr-1">🕒</span> 17:32 ng 12/08/2026
                                                                </p>
                                                                <p className="text-[12px] text-gray-600 dark:text-gray-400 mt-2">
                                                                    Thanh lý tài sản 1tesst, SL: 1 Chiếc, Giá tiền: 1 VNĐ
                                                                </p>
                                                            </div>
                                                            {/* Avatar chữ H bên phải */}
                                                            <div className="w-8 h-8 rounded-full bg-[#a3e635] text-white flex items-center justify-center text-xs font-bold shrink-0 ml-3">
                                                                H
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* --- ITEM TIMELINE 2 --- */}
                                                <div className="relative flex items-start group">
                                                    {/* Icon tròn màu hồng đậm bên trái */}
                                                    <div className="absolute -left-6 top-2 w-6 h-6 rounded-full bg-[#ec4899] text-white flex items-center justify-center shadow-sm z-10">
                                                        <RefreshCw size={12} />
                                                    </div>
                                                    {/* Card nội dung */}
                                                    <div className="flex-1 bg-[#f8f9fa] dark:bg-gray-800 p-4 rounded-md border border-gray-100 dark:border-gray-700 relative ml-2">
                                                        <div className="flex justify-between items-start">
                                                            <div>
                                                                <p className="text-[13px] text-gray-800 dark:text-gray-200">
                                                                    <span className="font-bold">bbb</span> <span className="text-gray-500">đã cấp phát tài sản</span>
                                                                </p>
                                                                <p className="text-[11px] text-gray-400 mt-0.5 flex items-center">
                                                                    <span className="mr-1">🕒</span> 17:26 ng 25/06/2026
                                                                </p>
                                                                <p className="text-[12px] text-gray-600 dark:text-gray-400 mt-2">
                                                                    Cấp phát cho Lê Hòa Bình (SL: 1 Chiếc)
                                                                </p>
                                                            </div>
                                                            {/* Avatar chữ B bên phải */}
                                                            <div className="w-8 h-8 rounded-full bg-gray-400 text-white flex items-center justify-center text-xs font-bold shrink-0 ml-3">
                                                                B
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* --- ITEM TIMELINE 3 --- */}
                                                <div className="relative flex items-start group">
                                                    {/* Icon tròn màu xanh lá bên trái */}
                                                    <div className="absolute -left-6 top-2 w-6 h-6 rounded-full bg-[#10b981] text-white flex items-center justify-center shadow-sm z-10">
                                                        <Plus size={12} />
                                                    </div>
                                                    {/* Card nội dung */}
                                                    <div className="flex-1 bg-[#f8f9fa] dark:bg-gray-800 p-4 rounded-md border border-gray-100 dark:border-gray-700 relative ml-2">
                                                        <div className="flex justify-between items-start">
                                                            <div>
                                                                <p className="text-[13px] text-gray-800 dark:text-gray-200">
                                                                    <span className="font-bold">bbb</span> <span className="text-gray-500">đã tạo mới</span>
                                                                </p>
                                                                <p className="text-[11px] text-gray-400 mt-0.5 flex items-center">
                                                                    <span className="mr-1">🕒</span> 17:25 ng 25/06/2026
                                                                </p>
                                                                <p className="text-[12px] text-gray-600 dark:text-gray-400 mt-2">
                                                                    ID: 1831 - 1tesst
                                                                </p>
                                                            </div>
                                                            {/* Avatar chữ B bên phải */}
                                                            <div className="w-8 h-8 rounded-full bg-gray-400 text-white flex items-center justify-center text-xs font-bold shrink-0 ml-3">
                                                                B
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    )
                                }
                            ]}
                        />
                    </div>
                </div>
            </div>

            {/* MODALS */}
            <Modal title={<span className="text-lg font-bold">Cấp phát tài sản</span>} open={isAllocateOpen} onCancel={() => setIsAllocateOpen(false)} footer={null} width={600} centered>
                <Form layout="vertical" className="mt-4">
                    <div className="grid grid-cols-2 gap-4">
                        <Form.Item label="Mã CP" required><Input defaultValue="BBBG_116" /></Form.Item>
                        <Form.Item label="Tài sản" required><Input defaultValue="1tesst" disabled className="bg-gray-50" /></Form.Item>
                    </div>
                    <Form.Item><Checkbox>Phòng ban</Checkbox></Form.Item>
                    <Form.Item label="Nhân sự nhận" required><Input placeholder="Nhân sự nhận" suffix={<Search size={16} className="text-gray-400" />} /></Form.Item>
                    <Form.Item label="Người cấp phát"><Input defaultValue="HQ_495 - Mr. Huân" suffix={<XCircle size={14} className="text-gray-400 cursor-pointer" />} /></Form.Item>
                    <div className="grid grid-cols-2 gap-4">
                        <Form.Item label="Số lượng" required><Input placeholder="Nhập số lượng" /></Form.Item>
                        <Form.Item label="Tồn kho"><Input defaultValue="Còn 9998 / 9999" disabled className="bg-gray-50" /></Form.Item>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                        <Form.Item label="Ngày cấp phát" required><DatePicker className="w-full" /></Form.Item>
                        <Form.Item label="Thời gian cấp phát" required><TimePicker className="w-full" /></Form.Item>
                    </div>
                    <Form.Item label="Vị trí tài sản"><Select placeholder="Chọn vị trí" suffixIcon={<ChevronDown size={14} />} /></Form.Item>
                    <Form.Item label="Địa điểm bàn giao"><Input /></Form.Item>
                    <Form.Item label="Đặt cọc"><Input /></Form.Item>
                    <Form.Item label="Nhập dự kiến ngày trả"><DatePicker className="w-full" /></Form.Item>
                    <Form.Item label="Lý do cấp phát"><TextArea rows={2} /></Form.Item>
                    <div className="flex justify-end space-x-2 mt-6">
                        <Button onClick={() => setIsAllocateOpen(false)}>HỦY BỎ</Button>
                        <Button type="primary" className="bg-orange-500 hover:bg-orange-600">CẬP NHẬT</Button>
                    </div>
                </Form>
            </Modal>

            <Modal title={<span className="text-lg font-bold">Thu hồi tài sản</span>} open={isRevokeOpen} onCancel={() => setIsRevokeOpen(false)} footer={null} width={600} centered>
                <Form layout="vertical" className="mt-4">
                    <div className="grid grid-cols-2 gap-4">
                        <Form.Item label="Mã thu hồi" required><Input defaultValue="BBTH_44" /></Form.Item>
                        <Form.Item label="Tài sản"><Input defaultValue="1tesst" disabled className="bg-gray-50" /></Form.Item>
                    </div>
                    <Form.Item label="Thu hồi cho lần cấp phát" required><Select placeholder="Chọn phiếu cấp phát" /></Form.Item>
                    <div className="grid grid-cols-2 gap-4">
                        <Form.Item label="Nhập số lượng thu hồi" required><Input /></Form.Item>
                        <Form.Item label="Cấp phát / tổng"><Input disabled className="bg-gray-50" /></Form.Item>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                        <Form.Item label="Trạng thái"><Select placeholder="Chọn trạng thái" /></Form.Item>
                        <Form.Item label="Người thu hồi"><Input defaultValue="HQ_495 - Mr. Huân" suffix={<XCircle size={14} className="text-gray-400 cursor-pointer" />} /></Form.Item>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                        <Form.Item label="Ngày thu hồi" required><DatePicker className="w-full" /></Form.Item>
                        <Form.Item label="Giờ trả" required><TimePicker className="w-full" /></Form.Item>
                    </div>
                    <Form.Item label="Địa điểm thu hồi"><Input /></Form.Item>
                    <Form.Item><Checkbox>Trả đặt cọc</Checkbox></Form.Item>
                    <Form.Item label="Lý do thu hồi"><TextArea rows={2} /></Form.Item>
                    <div className="flex justify-end space-x-2 mt-6">
                        <Button onClick={() => setIsRevokeOpen(false)}>HỦY BỎ</Button>
                        <Button type="primary" className="bg-orange-500 hover:bg-orange-600">CẬP NHẬT</Button>
                    </div>
                </Form>
            </Modal>

            <Modal title={<span className="text-lg font-bold">Phiếu báo hỏng</span>} open={isBrokenOpen} onCancel={() => setIsBrokenOpen(false)} footer={null} width={500} centered>
                <Form layout="vertical" className="mt-4">
                    <Form.Item label="Tài sản" required><Input defaultValue="TS.247-1tesst" disabled className="bg-gray-50" /></Form.Item>
                    <div className="grid grid-cols-3 gap-3">
                        <Form.Item label="Ngày báo" required><DatePicker className="w-full" /></Form.Item>
                        <Form.Item label="Số lượng" required><Input /></Form.Item>
                        <Form.Item label="Giá trị" required><Input /></Form.Item>
                    </div>
                    <Form.Item label="Mô tả"><TextArea rows={3} placeholder="Nhập mô tả" /></Form.Item>
                    <div className="flex justify-end space-x-2 mt-6">
                        <Button onClick={() => setIsBrokenOpen(false)}>HỦY BỎ</Button>
                        <Button type="primary" className="bg-orange-500 hover:bg-orange-600">CẬP NHẬT</Button>
                    </div>
                </Form>
            </Modal>

            <Modal title={<span className="text-lg font-bold">Phiếu bảo hành, sửa chữa</span>} open={isMaintenanceOpen} onCancel={() => setIsMaintenanceOpen(false)} footer={null} width={500} centered>
                <Form layout="vertical" className="mt-4">
                    <Form.Item label="Tài sản" required><Input defaultValue="TS.247-1tesst" disabled className="bg-gray-50" /></Form.Item>
                    <div className="grid grid-cols-2 gap-4">
                        <Form.Item label="Ngày báo" required><DatePicker className="w-full" /></Form.Item>
                        <Form.Item label="Giá trị"><Input /></Form.Item>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                        <Form.Item label="Số lượng" required><Input /></Form.Item>
                        <Form.Item label="Tồn kho"><Input defaultValue="Còn 9998 / 9999" disabled className="bg-gray-50" /></Form.Item>
                    </div>
                    <Form.Item label="Mô tả"><TextArea rows={3} placeholder="Nhập mô tả" /></Form.Item>
                    <div className="flex justify-end space-x-2 mt-6">
                        <Button onClick={() => setIsMaintenanceOpen(false)}>HỦY BỎ</Button>
                        <Button type="primary" className="bg-orange-500 hover:bg-orange-600">CẬP NHẬT</Button>
                    </div>
                </Form>
            </Modal>

            {/* CSS Tùy chỉnh màu Cam cho Ant Design Tabs & Table */}
            <style dangerouslySetInnerHTML={{
                __html: `
                .custom-antd-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn { color: #3e91ab !important; font-weight: 600; }
                .custom-antd-tabs .ant-tabs-ink-bar { background: #3e91ab !important; }
                .custom-antd-tabs .ant-tabs-tab:hover { color: #3e91ab !important; }
                .custom-inner-table .ant-table-wrapper .ant-table { border: none !important; }
                .custom-inner-table .ant-table-wrapper .ant-table-container { border-inline-start: none !important; border-inline-end: none !important; }
                .custom-inner-table th { text-transform: uppercase; font-size: 12px; }
            `}} />
        </Layout>
    );
};

export default AssetDetail;